import React, { Fragment, useEffect, useState } from 'react';
import {
  Dialog,
  DialogBackdrop,
  Transition,
  TransitionChild
} from '@headlessui/react';
import StyledImage from '../StyledImage';
import closeimg from '../../public/img/close-icn.svg';
import { useSelector } from 'react-redux';
import { IGlobalState } from '../../context/reducer';
import { useCookies } from 'react-cookie';
import moment from 'moment';
import { useRouter } from 'next/router';

const HomePopup = ({
  image,
  popupCookie,
  popupExpirationDays,
  link
}: {
  image: string;
  popupCookie: string;
  popupExpirationDays: number;
  link: string;
}) => {
  const { profile: { email } = {} } = useSelector<IGlobalState, IGlobalState>(
    state => state || {}
  );

  const [cookies, setCookie] = useCookies([popupCookie]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!cookies[popupCookie]) {
      setIsOpen(true);
    }
  }, [cookies]);

  function setExpirationCookie() {
    setCookie(popupCookie, true, {
      expires: moment().add(popupExpirationDays, 'days').toDate()
    });
  }

  function onClose() {
    setIsOpen(false);
    setExpirationCookie();
  }

  return (
    <Transition as="div" appear show={isOpen}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 flex items-center justify-center overflow-y-auto"
        onClose={onClose}
      >
        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <DialogBackdrop className="fixed inset-0 bg-black opacity-30" />
        </TransitionChild>

        <TransitionChild
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="z-20 flex flex-col w-full h-fit bg-white shadow-xl rounded-xl lg:max-w-[30vw] max-w-[80vw] md:max-w-[45vw]  overflow-hidden">
            <div className="relative h-full max-h-[90vh]">
              <button
                className="absolute z-10 flex items-center justify-center w-8 h-8 bg-white rounded-full top-6 right-6 focus:outline-none"
                onClick={onClose}
              >
                <StyledImage
                  src={closeimg}
                  className="flex justify-center overflow-hidden align-center"
                  alt="close icon"
                />
              </button>
              {link ? (
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  className="w-full block relative z-0"
                >
                  <img src={image} className="w-full m-auto" alt="newsletter" />
                </a>
              ) : (
                <img
                  src={image}
                  className="w-auto h-full m-auto"
                  alt="newsletter"
                />
              )}
            </div>
          </div>
        </TransitionChild>
      </Dialog>
    </Transition>
  );
};

export default HomePopup;
